import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer} data-footer="1">
      <div className={styles.content}>
        <Link to="/hilfe" className={styles.link}>Hilfe</Link>
        <Link to="/contact" className={styles.link}>Kontakt</Link>
        <Link to="/impressum" className={styles.link}>Impressum</Link>
        <Link to="/datenschutz" className={styles.link}>Datenschutz</Link>
        {/* Einfacher Link statt des früheren Buy-me-a-coffee-Widgets: das Skript lud bei jedem
            Seitenaufruf von cdnjs.buymeacoffee.com (Datenübertragung ohne Einwilligung). */}
        <a
          href="https://www.buymeacoffee.com/maxinatra"
          target="_blank"
          rel="noopener noreferrer"
          className={`${styles.link} ${styles.coffee}`}
          data-testid="footer-coffee"
        >
          <span aria-hidden="true">☕</span> Kaffee ausgeben
        </a>
        <span className={styles.copyright}>© {new Date().getFullYear()} Wankandoo</span>
      </div>
    </footer>
  );
};

export default Footer;
